import { Component, OnInit } from '@angular/core';
import { ApiPartnerService } from '@app/api/api-partner.service';
import { ActivatedRoute } from '@angular/router';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import Swal from 'sweetalert2';
import { AuthenticationService } from '@app/_services/authentication.service';

@Component({
  selector: 'app-order-view',
  templateUrl: './order-view.component.html',
  styleUrls: ['./listorder.component.css']
})
export class OrderViewComponent implements OnInit {

  orderData: any = [];
  purchaseOrderId = '0';
  customerId = '';
  isLoading = true;
  imgUploadForm = new FormGroup({
    name: new FormControl('', [Validators.required, Validators.minLength(3)]),
    file: new FormControl('', [Validators.required]),
    fileSource: new FormControl('', [Validators.required])
  });
  role: any = "";
  permision: string[] = [];
  currentuser: any = {};

  constructor(
    private route: ActivatedRoute,
    public partnerService: ApiPartnerService,
    private Auth: AuthenticationService
  ) {
  }

  ngOnInit(): void {
    this.purchaseOrderId = this.route.snapshot.paramMap.get('id');
    this.fetchOrder(this.purchaseOrderId);
    this.currentuser = this.Auth.currentUserValue;
    this.cekuser();
    this.permision = this.currentuser.permision;
  }

  cekuser() {
    const currentUser: any = this.Auth.currentUserValue;
    if (currentUser != null) {
      if (currentUser.role.roleName) {
        this.role = currentUser.role.roleName;
      }
    }
  }

  MyPermission(p) {
    if (this.permision.indexOf(p) > -1) {
      return true;
    } else {
      return false;
    }
  }

  fetchOrder(id) {
    return this.partnerService.GetViewNextsysOrder(id).subscribe((output: any) => {
      this.orderData = output.data;
    });
  }

  showCustomer(field) {
    if (this.orderData.customer === undefined) {
      return '';
    } else {
      return this.orderData.customer[field];
    }
  }

  showShipping(field) {
    if (this.orderData.shipping === undefined) {
      return '';
    } else {
      return this.orderData.shipping[field];
    }
  }

  fileExist() {
    return !!this.orderData.file;
  }

  imgPreview() {
    return this.imgUploadForm.get('fileSource').value.name;
  }

  submitImg() {
    Swal.fire({
      title: 'Upload Resi?',
      text: 'Apakah Anda yakin ingin mengupload gambar resi ini?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Ya, Upload',
      cancelButtonText: 'Batal'
    }).then((result) => {
      if (!result.isConfirmed) {
        return;
      }

      const formData = new FormData();
      formData.append('file_upload', this.imgUploadForm.get('fileSource').value);
      formData.append('purchaseorder_id', this.purchaseOrderId);

      Swal.fire({
        title: 'Mengupload...',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });

      this.partnerService.PostUploadFileResiNextsys(formData)
        .subscribe({
          next: (output: any) => {
            Swal.close();

            if (output.status) {
              Swal.fire({
                icon: 'success',
                title: 'Berhasil',
                text: output.message
              });
              this.fetchOrder(this.purchaseOrderId);
            } else {
              Swal.fire({
                icon: 'error',
                title: 'Gagal Upload',
                text: output.message || 'Terjadi kesalahan saat menyimpan file.'
              });
            }
          },
          error: (err) => {
            Swal.close();
            console.error('Upload error:', err);
            Swal.fire({
              icon: 'error',
              title: 'Server Error',
              text: 'Terjadi kesalahan saat menghubungi server.'
            });
          }
        });
    });
  }

  onFileChange(event) {
    if (event.target.files.length > 0) {
      const file: File = event.target.files[0];
      console.log(file);
      this.imgUploadForm.patchValue({
        fileSource: file
      });
    }
  }
}

